import { getCulture } from "../locale/lang"
import { padZero } from "./formatUtil"

export function formatLocalDate(dateOrStr: Date | string | undefined, dateFormat: "full" | "long" | "medium" | "short") {
    const date = typeof dateOrStr === "string" ? new Date(dateOrStr) : dateOrStr
    if (!date) {
        return ""
    }
    return date.toLocaleDateString(getCulture(), {
        dateStyle: dateFormat,
    })
}

export function formatLocalTime(dateOrStr: Date | string | undefined, timeFormat: "full" | "long" | "medium" | "short") {
    const date = typeof dateOrStr === "string" ? new Date(dateOrStr) : dateOrStr
    if (!date) {
        return ""
    }
    return date.toLocaleTimeString(getCulture(), {
        timeStyle: timeFormat,
    })
}

let cachedStringDateFormat: string | undefined = undefined
export function getStringLocaleDateFormat(): string {
    if (cachedStringDateFormat) {
        return cachedStringDateFormat
    }

    let testDate = new Date(2031, 5, 7).toLocaleDateString(getCulture())
    testDate = testDate.replace("2031", "yyyy")
    testDate = testDate.replace("31", "yy")
    testDate = testDate.replace("06", "MM")
    testDate = testDate.replace("6", "M")
    testDate = testDate.replace("07", "dd")
    testDate = testDate.replace("7", "d")

    cachedStringDateFormat = testDate

    return testDate
}

export function formatShortDateWithFormat(date: Date, format: string) {
    const dayOfMonth = date.getDate()
    const month = date.getMonth() + 1
    const year = date.getFullYear()
    let result = format
    if (format.includes("dd")) {
        result = result.replace("dd", padZero(dayOfMonth, 2))
    }
    if (format.includes("d")) {
        result = result.replace("d", dayOfMonth + "")
    }
    if (format.includes("MM")) {
        result = result.replace("MM", padZero(month, 2))
    }
    if (format.includes("M")) {
        result = result.replace("M", month + "")
    }
    if (format.includes("yyyy")) {
        result = result.replace("yyyy", year + "")
    }
    if (format.includes("yy")) {
        result = result.replace("yy", (year + "").substring(2, 4))
    }
    return result
}

export function addHours(date: Date, hours: number) {
    date = new Date(date.valueOf())
    date.setUTCHours(date.getUTCHours() + hours)
    return date
}

export function addDays(date: Date, days: number) {
    date = new Date(date.valueOf())
    date.setUTCDate(date.getUTCDate() + days)
    return date
}

export function addMonths(date: Date, months: number) {
    date = new Date(date.valueOf())
    date.setUTCMonth(date.getUTCMonth() + months)
    return date
}

export function addYears(date: Date, years: number) {
    date = new Date(date.valueOf())
    date.setUTCFullYear(date.getUTCFullYear() + years)
    return date
}
